/** Browser detection for quirks that features can't detect by themselves. */

/** Bluefy (the Web Bluetooth browser for iPad/iPhone) identifies itself as `Bluefy/<version>` in the UA. */
export function isBluefy(): boolean {
  return typeof navigator !== 'undefined' && /\bBluefy\//.test(navigator.userAgent ?? '');
}
